angular.module('galilai.creator').controller('ProductController', function ($timeout, $scope, $http, api, $rootScope) {

    $scope.product = {}
    $scope.current = null
    $scope.mode = 'create'
    $scope.loading = false

    $rootScope.$on('media.item.show', function(event, data) {
        if (!data || data.kind !== 'product') {
            return
        }
        $scope.product = {}
        angular.element('#product-modal').modal('show')
        $scope.current = data
        $scope.mode = 'create'

        if (getCurrentCurrency()) {
            $scope.product.currency = getCurrentCurrency()
            $scope.product.country = getCurrentCountry()
        }
    })

    $rootScope.$on('media.item.edit', function(event, data) {
        if (!data || data.kind !== 'product') {
            return
        }
        angular.element('#product-modal').modal('show')
        $scope.current = data
        $scope.product = data.item.data
        $scope.product._id = data.item._id
        $scope.mode = 'edit'

        $scope.loading = true

        api.getMedia($scope.product._id).then(function(response) {
            $scope.product = response.data.data
            $scope.product._id = response.data._id
        })
        .catch(function(error) {
            angular.element('#product-modal').modal('hide')
            showError(gettext('error.generic'))
        }).finally(function() {
            $scope.loading = false
            $timeout(angular.noop)
        })
    })

    // Refactor
    $scope.uploadProductMedia = function (file) {
        if (!file) {
            showError(gettext('error.invalid.file_type'))
            return;
        }
        // Limit number max files
        var formData = new FormData();
        for (var i = 0; i < file.length; i++) {
            formData.append('media', file[i]);
            formData.append('name', file[i].name);
        }

        formData.append('projectId', $scope.current.projectId);
        formData.append('collection', '__products__');

        let token = localStorage.getItem('auth.token');

        $scope.loading = true

        // TODO - Refactor
        $http({
            method: 'POST',
            url: window.BASE_URL + '/api/media/upload',
            data: formData,
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': undefined
            },
            transformRequest: angular.identity
        })
            .then(function (response) {
                if (!$scope.product.urls) {
                    $scope.product.urls = []
                }
                $scope.product.urls = $scope.product.urls.concat(response.data.urls)
                $scope.product.url = $scope.product.urls[0]
            })
            .catch(function (error) {
                showError(gettext('error.invalid.image'))
            }).finally(function () {
                $scope.loading = false
                angular.element('#productMediaInputModal').val(null);
            })
    }

    $scope.init = function() {
        console.log('Init Product')
    }

    $scope.removeMedia = function(url) {
        if (!$scope.product.urls) {
            return
        }
        let index = $scope.product.urls.indexOf(url)
        if (index > -1) {
            $scope.product.urls.splice(index, 1)
        }
        if ($scope.product.url === url) {
            $scope.product.url = $scope.product.urls[0]
        }
    }

    $scope.save = function() {
        let data = $scope.product
        data.projectId = $scope.current.projectId
        data.collection = $scope.current.collection

        if (!data.name) {
            showError(gettext('error.invalid.product.name'))
            return
        }
        if (!data.projectId) {
            showError(gettext('error.invalid.product.project'))
            return
        }
        if (!data.name || !data.projectId) {
            showError(gettext('error.invalid.product'))
            return
        }

        if (data.price > 0 && !data.currency) {
            showError(gettext('error.invalid.product.price'))
            return
        }

        $scope.loading = true
        if ($scope.mode === 'edit') {
            api.updateProduct(data._id, data).then(function(response) {
                if (!response || !response.data || !response.data._id) {
                    showError(gettext('error.generic'))
                    return
                }
                $rootScope.$emit('media.item.updated', {
                    source: $scope.current.source,
                    kind: 'product',
                    item: response.data
                })
                // Close modal
                angular.element('#product-modal').modal('hide')
                showSuccess(gettext('success.generic'))
            })
            .catch(function(error) {
                showError(gettext('error.generic'))
            })
            .finally(function() {
                $scope.loading = false
            })
        } else {
            api.createProduct(data).then(function(response) {
                if (!response || !response.data || !response.data._id) {
                    showError(gettext('error.generic'))
                    return
                }
                $rootScope.$emit('media.item.created', {
                    source: $scope.current.source,
                    kind: 'product',
                })
                // Close modal
                angular.element('#product-modal').modal('hide')
            })
            .catch(function(error) {
                if (error && error.data == "limit_products") {
                    $rootScope.showUpgrade('Add more products')
                    return
                }
                showError(gettext('error.generic'))
            })
            .finally(function() {
                $scope.loading = false
            })
        }
    }
})